import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { InputAdornment, IconButton, TextField, Paper, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { useNavStyles } from '../styles/muiStyles';
import SearchIcon from '@material-ui/icons/Search';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import backendUrl from '../backendUrl';

const SearchBar = ({ isMobile, setSearchOpen }) => {
  const [searchInput, setSearchInput] = useState('');
  const [results, setResults] = useState([]);
  const [debounceTimer, setDebounceTimer] = useState(null);
  const history = useHistory();
  const classes = useNavStyles();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchInput.trim() === '') return;
    history.push(`/search/${searchInput.trim()}`);
  };

  const clearSearch = () => {
    if (isMobile) setSearchOpen(false);
    setSearchInput('');
    setResults([]);
  };

  const fetchResults = async (query) => {
    if (!query) {
      setResults([]);
      return;
    }
    try {
      const response = await fetch(`${backendUrl}/api/peekgroups/searchGroups?q=${encodeURIComponent(query)}`);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      setResults(data.suggestions || []);  // fix: server returns suggestions
    } catch (error) {
      console.error('Search fetch failed:', error);
      setResults([]);
    }
  };

  useEffect(() => {
    if (debounceTimer) clearTimeout(debounceTimer);
    const timer = setTimeout(() => {
      fetchResults(searchInput.trim());
    }, 500);
    setDebounceTimer(timer);
    return () => clearTimeout(timer);
  }, [searchInput]);

  return (
    <div className={classes.search} style={{ position: 'relative' }}>
      <form onSubmit={handleSearch}>
        <TextField
          type="search"
          placeholder="Search for posts…"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          className={classes.inputField}
          variant="outlined"
          margin="dense"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="primary" />
              </InputAdornment>
            ),
            endAdornment: searchInput !== '' && (
              <InputAdornment position="end">
                <IconButton color="primary" size="small" onClick={clearSearch}>
                  <HighlightOffIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </form>

      {results.length > 0 && (
        <Paper elevation={3} style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 10 }}>
          <List>
            {results.map((result, index) => (
              <ListItem
                button
                key={index}
                onClick={() => history.push(`/p/${result.peekgroupName}`)}
              >
                <ListItemText
                  primary={`p/${result.peekgroupName}`}
                  secondary={
                    <Typography variant="caption" color="textSecondary">
                      {result.subscriberCount.toLocaleString()} members
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </div>
  );
};

export default SearchBar;
